import { Reveal, SectionHeading } from "../components/primitives";
import { PageHero, CTASection, Icon, BookButtons } from "../components/sections";
import { RTO_SERVICES } from "../data/site";

const Rto = () => (
  <>
    <PageHero
      eyebrow="RTO Support Ecosystem"
      lines={["More Than", "Driving Training."]}
      text="Learning licence guidance, real manual driving practice for RTO, lifetime free RTO consulting and a training completion certificate — DWC supports you before, during and after training."
    >
      <BookButtons bookTestId="rto-book-btn" waTestId="rto-whatsapp-btn" />
    </PageHero>
    <section className="bg-white py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <SectionHeading
          eyebrow="RTO Guidance"
          number="01"
          title="What DWC Guides You On"
          text="Learners can continue to approach DWC for RTO-related guidance within the scope of the service."
        />
        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {RTO_SERVICES.map((s, i) => (
            <Reveal key={s.title} delay={(i % 3) * 0.08} className="h-full">
              <article className="h-full rounded-2xl border border-gray-100 bg-white p-8 shadow-[0_8px_30px_rgb(0,0,0,0.04)] transition-[box-shadow,transform] duration-300 hover:-translate-y-1 hover:shadow-[0_20px_50px_rgb(23,107,58,0.10)]">
                <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-dwc-soft text-dwc-green">
                  <Icon name={s.icon} />
                </span>
                <h3 className="mt-5 text-lg font-extrabold tracking-tight text-dwc-charcoal">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-dwc-charcoal/65">{s.text}</p>
              </article>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.15}>
          <p className="mt-12 rounded-2xl border border-dwc-green/15 bg-dwc-soft p-6 text-sm leading-relaxed text-dwc-charcoal/70" data-testid="rto-disclaimer">
            <strong className="text-dwc-green">Please note:</strong> DWC provides guidance and consulting for RTO-related services. DWC is a private driving institute and is not the Regional Transport Office or any government authority. Licences are issued solely by the government RTO, and government fees apply as per law. The training completion certificate is a DWC training document, not a government licence or government certification.
          </p>
        </Reveal>
      </div>
    </section>
    <CTASection title="Need Licence Or RTO Guidance?" sub="Message DWC on WhatsApp with what you need — the team will guide you through the process." chapter="02" />
  </>
);

export default Rto;
